export default __webpack_public_path__ + "static/media/SFInstagram.b5d47344.png";